import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Banner, BannerRevision, Client } from '../../shared/models/models';

export interface ClientsPage {
  content: Client[];
  total_elements: number;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);
  private api = environment.apiUrl;

  getClients(page: number, query: string): Observable<ClientsPage> {
    const params = new URLSearchParams({ size: '25', page: String(page), sort: 'name,asc' });
    const isId = /^\d+$/.test(query.trim());
    if (query.trim()) {
      isId ? params.set('client_ids', query.trim()) : params.set('name', query.trim());
    }
    return this.http.get<ClientsPage>(`${this.api}clients?${params}`);
  }

  getBanners(clientId: number): Observable<Banner[]> {
    return this.http.get<Banner[]>(`${this.api}banners?client_id=${clientId}`);
  }

  getBannerRevisions(bannerId: number): Observable<BannerRevision[]> {
    return this.http.get<BannerRevision[]>(`${this.api}banners/${bannerId}/revisions`);
  }

  getAuditStatus(bannerIds: number[]): Observable<number[]> {
    const params = bannerIds.map(id => `banner_ids=${id}`).join('&');
    return this.http.get<number[]>(`${this.api}banners/audit-status?${params}`);
  }
}
